import React from 'react'
import styles from './switcher.module.scss'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const Switcher = ({ className, ...rest }) => {
  return (
    <input
      className={clsx(styles['root'], className)}
      type="checkbox"
      {...rest}
    />
  )
}

Switcher.propTypes = { className: PropTypes.string }

export default Switcher
